/**
 * Dummy data for Protocols view:
 * - Business lines
 * - 1–3 clients per business line
 * - 1–5 agents per business line
 * - Each client has 1–5 calls
 * - Each client is linked to exactly 1 agent (that agent makes all the calls)
 */

// You can adjust or extend these business lines to match your backend IDs/names
const businessLines = [
  { id: 1, name: 'Defensa Deudores' },
  { id: 2, name: 'Defensa Familia' },
  { id: 3, name: 'Defensa Laboral' },
  { id: 4, name: 'Línea de Prueba' },
];

// Helpers
const randomInRange = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const randomRUT = () => {
  const body = randomInRange(5000000, 25000000);
  const dvRaw = randomInRange(0, 10);
  const dv = dvRaw === 10 ? 'K' : dvRaw;
  return `${body}-${dv}`;
};

const randomPastDateISO = (daysBack = 30) => {
  const now = new Date();
  const offsetDays = randomInRange(0, daysBack);
  const d = new Date(now.getTime() - offsetDays * 24 * 60 * 60 * 1000);
  return d.toISOString();
};

// Generators
const generateAgentsForBusinessLine = (businessLineId) => {
  const count = randomInRange(1, 5);
  return Array.from({ length: count }).map((_, i) => ({
    id: Number(`${businessLineId}1${i + 1}`),
    firstName: `Agente ${businessLineId}-${i + 1}`,
    lastName: `Apellido ${i + 1}`,
    rut: randomRUT(),
    businessLineId,
    employeeCode: `EMP-${businessLineId}-${i + 1}`,
  }));
};

const generateClientsForBusinessLine = (businessLineId, agents) => {
  const count = randomInRange(1, 3);

  return Array.from({ length: count }).map((_, i) => {
    const clientId = Number(`${businessLineId}0${i + 1}`);

    // Assign a single agent per client (this agent makes all the calls)
    const assignedAgent =
      agents[randomInRange(0, Math.max(agents.length - 1, 0))];

    const callsCount = randomInRange(1, 5);
    const calls = Array.from({ length: callsCount }).map((__, j) => ({
      id: Number(`${clientId}${j + 1}`),
      date: randomPastDateISO(30),
      durationMinutes: randomInRange(3, 45),
      clientId,
      agentId: assignedAgent?.id,
      businessLineId,
    }));

    return {
      id: clientId,
      firstName: `Cliente ${businessLineId}-${i + 1}`,
      lastName: `Apellido ${i + 1}`,
      rut: randomRUT(),
      businessLineId,
      agentId: assignedAgent?.id,
      calls,
    };
  });
};

// Build mock dataset grouped by business line
const protocolDummyData = businessLines.map((bl) => {
  const agents = generateAgentsForBusinessLine(bl.id);
  const clients = generateClientsForBusinessLine(bl.id, agents);

  return {
    businessLineId: bl.id,
    businessLineName: bl.name,
    agents,
    clients,
  };
});

export default protocolDummyData;
